import React from 'react'

const Arrow: React.FC = () => (
  <svg viewBox="0 0 182.95952 29.302568" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <defs id="defs2">
      <marker
        style={{ overflow: 'visible' }}
        id="Arrow1"
        refX="0"
        refY="0"
        orient="auto-start-reverse"
        markerWidth="4.0606604"
        markerHeight="6.7071066"
        viewBox="0 0 4.0606602 6.7071068"
        preserveAspectRatio="xMidYMid"
      >
        <path
          style={{ fill: 'none', stroke: 'context-stroke', strokeWidth: 1, strokeLinecap: 'butt' }}
          d="M 3,-3 0,0 3,3"
          transform="rotate(180,0.125,0)"
        />
      </marker>
    </defs>
    <g transform="translate(-17.035653,-111.15763)">
      <path
        style={{
          fill: 'none',
          stroke: 'currentcolor',
          strokeWidth: 1.3,
          strokeDasharray: '1.3, 7.80001',
          strokeDashoffset: 0,
          markerStart: 'url(#Arrow1)',
        }}
        d="m 198.05923,139.41991 c -10.76313,-16.40362 -40.64417,-27.61893 -90.51489,-27.6195 -49.868302,0.002 -80.123907,10.27076 -90.508687,27.6195"
      />
    </g>
  </svg>
)

export default Arrow
